import { render, staticRenderFns } from "./Printouts.vue?vue&type=template&id=56e251c3&scoped=true&"
import script from "./Printouts.vue?vue&type=script&lang=js&"
export * from "./Printouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e251c3",
  null
  
)

export default component.exports